import styled from 'styled-components';

export default styled.div`
  position: relative;

  > div:first-child {
    position: absolute;
    top: -25px;
    right: 5px;
    z-index: 100;
    min-height: 130px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;
